import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "action"]
  static values = { threshold: { type: Number, default: 80 } }

  connect() {
    this.startX = 0
    this.currentX = 0
    this.swiping = false
  }

  pointerdown(event) {
    this.startX = event.clientX
    this.swiping = true
    this.itemTarget.style.transition = "none"
  }

  pointermove(event) {
    if (!this.swiping) return

    const diff = this.startX - event.clientX
    if (diff < 0) return

    this.currentX = Math.min(diff, this.thresholdValue + 20)
    this.itemTarget.style.transform = `translateX(-${this.currentX}px)`
    this.actionTarget.style.opacity = Math.min(this.currentX / this.thresholdValue, 1)
  }

  pointerup() {
    if (!this.swiping) return
    this.swiping = false
    this.itemTarget.style.transition = "transform 0.2s ease-out"

    if (this.currentX >= this.thresholdValue) {
      this.itemTarget.style.transform = `translateX(-100%)`
      this.itemTarget.style.opacity = "0"
      setTimeout(() => this.actionTarget.closest("form")?.requestSubmit(), 200)
    } else {
      this.itemTarget.style.transform = "translateX(0)"
      this.actionTarget.style.opacity = "0"
    }
    this.currentX = 0
  }

  pointercancel() {
    this.pointerup()
  }
}
